import React, { Component } from "react";
import { Image, Button, Row, Col } from "react-bootstrap";

class EditModelBody extends Component {
  state = {
    ordertype: 0,
  };
  render() {
    const { ordertype } = this.state;
    return (
      <React.Fragment>
        <div className="superadmin-orderscomponent-main">
          Select one relevant option from below
          <br />
          <div>
            <Row style={{ marginLeft: "2%" }}>
              {orderTypes.map((data) => {
                return (
                  <Col
                    xs={3}
                    sm={3}
                    md={3}
                    className={`take-away-order-select 
                                  ${
                                    ordertype === data.id &&
                                    `take-away-order-select-selected`
                                  }`}
                    onClick={() => {
                      this.setState({ ordertype: data.id });
                    }}
                    style={{
                      padding: "2%",
                      marginRight: "1%",
                      marginBottom: "1%",
                    }}
                    key={data.id}
                  >
                    <span>{data.title}</span>
                  </Col>
                );
              })}
            </Row>
          </div>
          <div className="d-flex align-items-center pt-5">
            <Button
              variant="outline-secondary"
              className="mr-4 px-5 py-2"
              //   onClick={(e) => this.props.history.push("/superadminorders")}
            >
              Cancel
            </Button>
            <Button
              variant="danger"
              className="px-5  py-2"
              //onClick={(e) => handleShowTab("2")}
              //type="submit"
              //   onClick={() => onClickStepOne()}
            >
              Update
            </Button>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const orderTypes = [
  { id: 0, title: "All Day" },
  { id: 1, title: "Breakfast" },
  { id: 2, title: "Lunch" },
  { id: 3, title: "Dinner" },
  { id: 4, title: "Other" },
];

export default EditModelBody;
